import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=5b6927ed&"
import script from "./AddDevice.vue?vue&type=script&lang=js&"
export * from "./AddDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6927ed')) {
      api.createRecord('5b6927ed', component.options)
    } else {
      api.reload('5b6927ed', component.options)
    }
    module.hot.accept("./AddDevice.vue?vue&type=template&id=5b6927ed&", function () {
      api.rerender('5b6927ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/adddevice/AddDevice.vue"
export default component.exports